module.exports = __webpack_public_path__ + "img/guide_ot.d45fc5f1.png";